import React from 'react';
import SectionHeader from 'components/text/SectionHeader';
import Button from 'components/common/Button';
import Modal from 'components/common/Modal';
import LineItemsTable from './LineItemsTable';
import CreateLineItem from './CreateLineItem';
import SaveLineItem from './SaveLineItem';

class PricingAndPackaingArea extends React.PureComponent {
  state = {
    createModalIsVisible: false,
    saveModalIsVisible: false,
    editLineItem: null,
  };

  toggleCreate = () => {
    this.setState({ createModalIsVisible: !this.state.createModalIsVisible });
  };

  toggleSave = () => {
    this.setState({ saveModalIsVisible: !this.state.saveModalIsVisible });
  };

  handleEdit = lineItem => {
    this.setState({ editLineItem: lineItem });
    this.toggleSave();
  };

  render() {
    const { createModalIsVisible, saveModalIsVisible, editLineItem } = this.state;
    return (
      <div>
        <div style={{ width: 650, maxWidth: '100%', position: 'relative' }}>
          <SectionHeader>PACKAGES</SectionHeader>
          <Button
            style={{
              position: 'absolute',
              right: 0,
              top: -7,
              width: 175,
            }}
            onClick={this.toggleCreate}
          >
            ADD PRICING ITEM
          </Button>
          <div>
            <LineItemsTable onEdit={this.handleEdit} />
          </div>
          {/* Force re-render to clear form fields */}
          {createModalIsVisible && (
            <Modal
              visible={createModalIsVisible}
              footer={null}
              title="ADD LINE ITEM"
              className="post-modal"
              onCancel={this.toggleCreate}
            >
              <div className="flex justify-center align-center mx-auto">
                <CreateLineItem
                  onCancel={this.toggleCreate}
                  currencySymbol={this.props.currencySymbol}
                  onComplete={this.toggleCreate}
                />
              </div>
            </Modal>
          )}
          {/* Force re-render to clear form fields */}
          {saveModalIsVisible && (
            <Modal visible={saveModalIsVisible} footer={null} title="EDIT LINE ITEM" onCancel={this.toggleSave}>
              <div className="flex justify-center align-center mx-auto">
                <SaveLineItem lineItem={editLineItem} onCancel={this.toggleSave} onComplete={this.toggleSave} />
              </div>
            </Modal>
          )}
        </div>
      </div>
    );
  }
}

export default PricingAndPackaingArea;



// WEBPACK FOOTER //
// ./src/routes/app-studio/PricingAndPackagingArea/index.js